<template>
  <div>
    <el-select
      size="small"
      v-model="filter_form[filter_key]"
      :placeholder="placeholder"
      filterable
      @change="handleChange"
    >
      <el-option
        v-for="(data, index) in allEntityDataList"
        :key="index"
        :value="data.templates_fields_data[filterDetails.primary_fields[0]]"
        :label="data.templates_fields_data[filterDetails.primary_fields[0]]"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { postAPICall } from "../../helpers/httpHelper";

export default {
  props: {
    filter_key: String,
    filter_form: Object,
    filterDetails: Object,
    quickFilterValue: String,
    currentEntity: Object,
    placeholder: String,
  },
  data() {
    return {
      page: 1,
      allEntityDataList: [],
    };
  },
  mounted() {
    this.getFilterData();
  },
  methods: {
    async getFilterData() {
      try {
        let params = {
          entity_id: this.filterDetails.entity_id,
          template_fields_data: [
            {
              template_id: this.filterDetails.primary_fields[0].split("#")[0],
              fields: [this.filterDetails.primary_fields[0].split("#")[1]],
            },
          ],
          filters: [],
          page: this.page,
          limit: 500,
        };
        let result = await this.getEntityData(params);
        this.allEntityDataList = [...this.allEntityDataList, ...result.data];
      } catch (err) {
        console.log("Err", err);
      }
    },
    handleChange(value) {
      this.$emit("quick-filter-change", value);
    },
    async getEntityData(params) {
      try {
        let response = await postAPICall(
          "POST",
          "/entities-data/entity/data/v2",
          params
        );
        return response.data;
      } catch (err) {
        console.log("Err", err);
      }
    },
  },
};
</script>
